var _radialGradient, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanadaAtlantic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100.482",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 30.665,
    cy: 18.336,
    r: 30.167,
    fx: 30.643,
    fy: 18.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d5c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#f3c5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#ec9c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#e98c85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#e98782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#e87878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#e66069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e44055"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M13.87 22.89v.98h-.82v1.88l.02.66a.33.33 0 0 0 .11.16c.05.04.12.06.2.06.11 0 .27-.04.48-.12l.1.95c-.28.12-.6.18-.95.18a1.59 1.59 0 0 1-.59-.11c-.17-.08-.3-.17-.38-.29s-.14-.28-.17-.48c-.03-.14-.04-.43-.04-.87v-2.03h-.55v-.98h.55v-.92l1.21-.72v1.64h.83z"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m93.04 50.204-.009-.009c.773-1.536 1.223-3.238 1.223-5.05 0-6.494-5.574-11.756-12.446-11.756-3.339 0-6.365 1.251-8.601 3.275l-2.842-2.336H10.712c-2.732 0-4.967 2.29-4.967 5.096v17.763c0 2.796 2.235 5.096 4.967 5.096H56.2l5.004 4.811h20.099l8.297-11.94c1.361-1.794 2.907-3.955 3.376-4.857l.064-.092z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.19 45.642c0 3.247-2.704 5.878-6.034 5.878s-6.034-2.631-6.034-5.878 2.704-5.878 6.034-5.878 6.034 2.631 6.034 5.878z",
    fill: "#2da3d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.179 64.416h4.452l.616-5.004h1.141c1.867-.239 3.919-2.263 5.335-3.652l.055-.708-1.352-1.38-4.636 1.38 2.143-17.376-1.325-1.251-18.774 21.571 1.38 1.417h11.59l-1.904 3.55 1.279 1.453zm2.364-19.161-1.205 9.797H57l7.543-9.797zm18.636-8.122c-5.105.101-10.643 4.774-11.195 9.741-.543 4.967 3.633 8.518 9.217 8.233.064 0 .129-.009.193-.009l-8.527 7.883 1.849 1.453h4.848c2.704-3.707 10.91-13.632 11.756-17.707 1.113-5.4-2.925-9.695-8.141-9.594zm3.394 9.557c-.285 2.806-3.146 4.636-5.804 4.691s-4.25-2.281-3.965-5.096c.285-2.806 3.045-4.857 5.703-4.921 2.668-.055 4.351 2.52 4.066 5.326z",
    fill: "#e0f5f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m62.354 63.901 3.799-.028.616-5.004h1.141c1.867-.239 3.919-2.263 5.335-3.652l-.874-.846-2.557.147-2.502-.009 2.079-16.861-1.104-1.058-18.13 21.221.966 1.049h11.195l-1.104 3.882 1.141 1.159zm1.711-19.188-1.214 9.797h-6.329l7.543-9.797zm18.627-8.122c-5.105.101-10.643 4.774-11.195 9.741-.543 4.967 3.633 8.518 9.217 8.233.064 0 .129-.009.193-.009l-7.23 8.398 1.067.938h4.333c2.704-3.707 10.468-12.998 11.314-17.073 1.113-5.4-2.474-10.33-7.699-10.229zm3.394 9.557c-.359 2.796-3.146 4.636-5.804 4.691s-4.139-1.794-3.854-4.609c.285-2.806 2.815-4.976 5.473-5.041 2.668-.055 4.59 1.84 4.185 4.958z",
    fill: "#d5d5d8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.9 62.963h4.425l.616-4.967h1.131c1.858-.239 3.891-2.244 5.298-3.624l.055-.699h-5.95l2.134-17.247h-4.434L51.058 53.663l-1.067 4.323h11.526l-.616 4.976zm2.346-19.014-1.205 9.723H55.74l7.506-9.723zm18.517-8.058c-5.068.101-9.649 3.854-10.229 9.981-.469 4.93 3.128 8.628 8.26 7.856.064-.009.129-.009.193-.009l-7.129 9.272h5.308c2.695-3.67 10.845-13.531 11.691-17.579 1.104-5.363-2.907-9.631-8.095-9.521zm3.495 8.831c-.285 2.787-2.658 5.087-5.298 5.151-2.649.055-4.572-1.969-4.296-4.765.285-2.787 2.741-5.105 5.39-5.16 2.64-.055 4.48 1.996 4.204 4.774z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m15.156 46.966-.791-2.198h-2.842l-.745 2.198H7.705l3.9-10.726h2.668l4.001 10.735h-3.118zm-1.748-4.884-.488-1.417-.478 1.417h.966z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.501 46.433h-1.978l-.791-2.198h-3.597l-.745 2.198H8.459l3.514-9.668h1.923l3.606 9.668zm-3.348-3.817-1.242-3.587-1.214 3.587h2.456z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.224 47.123c-.386 0-.745-.074-1.058-.212-.34-.156-.607-.368-.773-.626a2.35 2.35 0 0 1-.322-.938c-.028-.147-.064-.46-.064-1.38v-2.53h-.791v-2.539h.791v-1.15L20.803 36v2.898h1.177v2.539h-1.177v2.29l.018.791c.055-.018.193-.046.432-.138l.653-.258.258 2.511-.35.156c-.469.221-1.003.331-1.591.331z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.447 39.433v1.481H20.27v2.824l.037 1.003a.363.363 0 0 0 .156.23.451.451 0 0 0 .294.092c.156 0 .386-.055.699-.175l.147 1.435a3.242 3.242 0 0 1-1.361.276 2.09 2.09 0 0 1-.846-.166c-.248-.11-.432-.258-.552-.432s-.202-.423-.239-.717c-.037-.212-.055-.653-.055-1.306v-3.063h-.809v-1.481h.791v-1.389l1.729-1.085v2.474h1.187z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.119 36.241h2.787v10.735h-2.787z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.652 46.433v-9.668h1.729v9.668h-1.729z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.859 47.123c-.819 0-1.481-.248-1.969-.745s-.736-1.122-.736-1.858a2.67 2.67 0 0 1 .331-1.325 2.36 2.36 0 0 1 .957-.92 3.661 3.661 0 0 1 .598-.248l-1.84-.359.138-.552c.202-.791.58-1.398 1.104-1.794.534-.396 1.26-.598 2.235-.598.865 0 1.509.12 1.969.35.478.248.819.58 1.021.975.193.386.285.993.285 1.904l-.018 2.171c0 .58.028 1.003.074 1.26.046.248.138.524.276.819l.34.754h-2.907l-.138-.368a3.56 3.56 0 0 1-.442.248 2.837 2.837 0 0 1-1.279.285zm.957-3.247c-.598.138-.736.23-.745.239-.092.074-.12.138-.12.221a.423.423 0 0 0 .12.304.39.39 0 0 0 .304.12c.193 0 .377-.074.561-.221a.561.561 0 0 0 .221-.331c.009-.037.037-.138.046-.423l-.386.092zm-.248-2.649c-.184 0-.322.028-.396.092-.037.028-.138.129-.23.423l-.028.074c.018 0 .028-.009.046-.009l1.242-.304c-.018-.147-.064-.184-.064-.193s-.11-.083-.57-.083z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.436 41.567-1.564-.304c.175-.681.478-1.177.911-1.499s1.067-.488 1.913-.488c.773 0 1.343.101 1.72.294s.644.442.8.745.23.855.23 1.656l-.018 2.162c0 .616.028 1.067.083 1.361a3.87 3.87 0 0 0 .313.938h-1.711a6.053 6.053 0 0 1-.166-.543l-.064-.221c-.294.304-.607.543-.947.69-.34.156-.69.23-1.076.23-.671 0-1.205-.193-1.591-.589-.386-.386-.58-.883-.58-1.481a2.125 2.125 0 0 1 .267-1.058 1.68 1.68 0 0 1 .745-.708c.313-.166.773-.313 1.371-.432.809-.166 1.361-.313 1.674-.451v-.184c0-.359-.083-.607-.248-.763-.166-.147-.469-.23-.929-.23-.304 0-.543.064-.717.193-.166.129-.313.359-.414.681zm2.309 1.509c-.221.083-.57.175-1.049.285s-.791.221-.938.322c-.23.175-.34.386-.34.653a.944.944 0 0 0 .957.956c.313 0 .607-.11.892-.331a1.122 1.122 0 0 0 .414-.616c.046-.156.064-.46.064-.901v-.368z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.818 46.966v-4.103c0-.975-.064-1.242-.083-1.297a.45.45 0 0 0-.175-.258.432.432 0 0 0-.285-.083.837.837 0 0 0-.488.156.773.773 0 0 0-.294.423c-.037.138-.11.506-.11 1.453v3.707h-2.787v-8.067h2.668v.304a2.9 2.9 0 0 1 1.619-.469 3.045 3.045 0 0 1 1.269.267c.396.184.708.432.929.736.202.285.34.616.423.975.074.331.11.773.11 1.361v4.884h-2.796z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.081 46.433h-1.729v-3.578c0-.754-.037-1.242-.11-1.472a1.006 1.006 0 0 0-.359-.515 1.003 1.003 0 0 0-.598-.184 1.334 1.334 0 0 0-.809.267 1.269 1.269 0 0 0-.488.699c-.092.285-.129.828-.129 1.61v3.174H33.13v-7h1.601v1.03c.57-.791 1.288-1.187 2.152-1.187a2.493 2.493 0 0 1 1.049.221c.313.147.552.34.717.561.166.23.276.488.34.782.064.285.092.708.092 1.242v4.351z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.595 47.123c-.386 0-.745-.074-1.058-.212-.34-.156-.607-.368-.773-.626-.166-.248-.267-.552-.322-.938-.028-.147-.064-.46-.064-1.38v-2.53h-.791v-2.539h.791v-1.15L43.174 36v2.898h1.177v2.539h-1.177v2.29l.018.791c.055-.018.193-.046.432-.138l.653-.258.258 2.511-.35.156c-.469.221-1.003.331-1.591.331z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.819 39.433v1.481h-1.177v2.824l.037 1.003a.363.363 0 0 0 .156.23.451.451 0 0 0 .294.092c.156 0 .386-.055.69-.175l.147 1.435a3.242 3.242 0 0 1-1.361.276 2.03 2.03 0 0 1-.837-.166c-.248-.11-.432-.258-.552-.432s-.202-.423-.239-.717c-.037-.212-.055-.653-.055-1.306v-3.063h-.791v-1.481h.791v-1.389l1.729-1.085v2.474h1.168z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.49 36.241h2.787v10.735H44.49z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.024 38.485v-1.72h1.729v1.711h-1.729zm0 7.948v-7h1.729v7h-1.729z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.269 47.123c-1.113 0-2.014-.386-2.686-1.15-.653-.745-.984-1.766-.984-3.036 0-1.288.331-2.309.984-3.054.671-.763 1.582-1.15 2.704-1.15.911 0 1.665.221 2.226.662s.957 1.095 1.196 1.959l.147.552-2.806.543-.083-.543c-.037-.239-.11-.414-.221-.515-.064-.055-.184-.138-.432-.138-.267 0-.46.083-.616.276-.101.12-.267.451-.267 1.269 0 .929.175 1.297.285 1.435a.708.708 0 0 0 .626.304c.248 0 .368-.092.442-.156s.202-.248.285-.736l.092-.524 2.76.506-.11.534c-.202.947-.598 1.683-1.187 2.189-.598.515-1.389.773-2.355.773z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.204 41.502-1.702.331c-.055-.368-.184-.644-.386-.828s-.469-.276-.791-.276c-.432 0-.773.156-1.03.478s-.386.855-.386 1.601c0 .828.129 1.417.386 1.757s.607.515 1.049.515c.331 0 .598-.101.809-.304s.359-.543.442-1.03l1.693.313c-.175.837-.515 1.463-1.012 1.895-.497.423-1.168.644-2.005.644-.957 0-1.72-.322-2.281-.966-.57-.644-.846-1.545-.846-2.686 0-1.159.285-2.051.855-2.704.57-.644 1.343-.966 2.309-.966.791 0 1.426.184 1.895.552.46.368.8.92 1.003 1.674z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.626 57.738-.506-1.343h-1.564l-.478 1.343H7.696l2.658-6.973h1.959l2.732 6.973z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.263 57.204h-1.269l-.506-1.343h-2.309l-.478 1.343H8.468l2.254-5.906h1.233l2.309 5.906zm-2.143-2.336-.8-2.189-.782 2.189h1.582z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.011 57.83c-.267 0-.524-.046-.745-.147-.258-.11-.451-.258-.58-.451a1.53 1.53 0 0 1-.239-.662c-.018-.101-.046-.304-.046-.883v-1.334h-.506v-1.969h.506v-.626l2.171-1.297v1.913h.754v1.969h-.754v1.407c.009-.009.681-.248.681-.248l.212 1.95-.359.156a2.539 2.539 0 0 1-1.095.221z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 31.888,
    x: 4.221,
    transform: "translate(.151 2.539) scale(.9199)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.032 50.765h2.171v6.973h-2.171z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.566 57.204v-5.906h1.104v5.906h-1.104z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.905 57.83c-.57 0-1.039-.175-1.389-.506a1.748 1.748 0 0 1-.534-1.288c0-.34.083-.644.248-.92a1.63 1.63 0 0 1 .488-.515l-.745-.138.156-.561c.147-.534.405-.938.782-1.214.377-.267.874-.396 1.545-.396.58 0 1.021.074 1.343.239.34.166.589.396.745.681.147.267.212.671.212 1.26l-.009 1.325c0 .423.028.626.046.727.028.138.083.285.156.451l.359.763h-2.3l-.055-.147-.12.055a2.327 2.327 0 0 1-.929.184zm.616-1.978c-.304.064-.386.11-.386.11l.11.009c.055 0 .138-.009.258-.101l.018-.018z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.638 54.233-1.003-.184c.11-.414.304-.717.58-.92s.69-.294 1.233-.294c.497 0 .865.055 1.104.184.239.12.414.267.506.451.101.184.147.524.147 1.012l-.009 1.325c0 .377.018.653.055.828a2.373 2.373 0 0 0 .202.57h-1.095l-.11-.331-.037-.138a2.14 2.14 0 0 1-.607.423 1.711 1.711 0 0 1-.69.138c-.432 0-.773-.12-1.021-.359s-.368-.543-.368-.911a1.242 1.242 0 0 1 .166-.644 1.09 1.09 0 0 1 .478-.432c.202-.101.497-.184.883-.267.515-.101.874-.193 1.076-.276v-.11c0-.221-.055-.377-.156-.469s-.304-.138-.598-.138c-.193 0-.35.037-.46.12-.12.083-.212.221-.276.423zm1.481.92c-.138.046-.368.11-.671.175s-.506.129-.607.193a.469.469 0 0 0-.221.396c0 .156.055.294.175.414s.267.175.442.175a.92.92 0 0 0 .57-.202.717.717 0 0 0 .267-.377c.028-.092.046-.285.046-.552v-.221z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.47 57.738v-2.714c0-.57-.037-.708-.046-.727-.046-.064-.074-.074-.11-.074a.34.34 0 0 0-.212.064.248.248 0 0 0-.11.156c-.018.046-.055.23-.055.819v2.465h-2.171v-5.344h2.088v.074a2.171 2.171 0 0 1 .846-.166c.322 0 .616.064.883.184.285.129.515.304.671.515.147.202.248.423.313.671.055.221.074.506.074.883v3.192H26.47z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.107 57.204h-1.104v-2.18c0-.46-.028-.763-.074-.901s-.12-.239-.23-.313a.66.66 0 0 0-.386-.11.84.84 0 0 0-.515.166c-.156.11-.258.248-.313.423s-.083.506-.083.984v1.941h-1.104v-4.277h1.03v.626c.368-.488.828-.727 1.38-.727.248 0 .469.046.671.138s.359.202.46.34.175.294.221.478a3.85 3.85 0 0 1 .064.763v2.649z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.37 57.83c-.267 0-.524-.046-.745-.147-.258-.11-.451-.258-.58-.451a1.53 1.53 0 0 1-.239-.662c-.018-.101-.046-.304-.046-.883v-1.334h-.506v-1.969h.506v-.626l2.171-1.297v1.913h.754v1.969h-.754v1.407c.009-.009.671-.248.671-.248l.212 1.95-.359.156c-.322.156-.69.221-1.085.221z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 19.831,
    y: 31.888,
    transform: "translate(.151 2.539) scale(.9199)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.391 50.765h2.171v6.973h-2.171z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.916 52.347v-1.049h1.104v1.049h-1.104zm0 4.857v-4.277h1.104v4.277h-1.104z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.368 59.366V57.71a2.01 2.01 0 0 1-.708.12 2.024 2.024 0 0 1-1.582-.736c-.442-.524-.671-1.223-.671-2.079 0-.819.212-1.481.644-1.959a2.12 2.12 0 0 1 1.665-.754c.267 0 .515.046.736.129v-.037h2.088v6.973h-2.171zm-.35-5.114c-.092 0-.175.018-.267.138-.046.055-.147.23-.147.699 0 .46.092.626.138.681.083.101.156.12.23.12.037 0 .129 0 .258-.156.11-.138.166-.377.166-.708 0-.405-.092-.58-.147-.644-.074-.11-.147-.129-.23-.129z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.901 58.832V56.68a1.518 1.518 0 0 1-.543.451c-.212.11-.451.166-.699.166a1.472 1.472 0 0 1-1.177-.552c-.359-.423-.543-1.003-.543-1.739 0-.69.166-1.223.515-1.61.34-.386.763-.58 1.269-.58.276 0 .524.055.727.184a1.64 1.64 0 0 1 .543.552v-.635h1.021v5.906h-1.113zm.037-3.817c0-.442-.092-.763-.258-.975a.841.841 0 0 0-1.324 0c-.184.221-.267.561-.267 1.039 0 .469.083.809.258 1.021s.386.313.644.313.478-.12.671-.35c.175-.239.276-.589.276-1.049z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.461 57.83a2.005 2.005 0 0 1-1.021-.258 1.667 1.667 0 0 1-.708-.782c-.129-.304-.193-.681-.193-1.159v-3.238h2.171v2.502l.037.957c.037.046.064.055.12.055a.313.313 0 0 0 .202-.064c.074-.055.101-.101.11-.138 0-.009.055-.193.055-.975v-2.336h2.171v5.344h-2.088v-.074a2.25 2.25 0 0 1-.855.166z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85 57.204v-.644c-.156.23-.35.405-.598.543a1.709 1.709 0 0 1-.791.202 1.46 1.46 0 0 1-.754-.193 1.141 1.141 0 0 1-.488-.534c-.101-.23-.147-.543-.147-.947v-2.704h1.104v1.969c0 .598.018.966.064 1.104a.57.57 0 0 0 .221.322c.11.083.248.12.414.12a.87.87 0 0 0 .506-.156.84.84 0 0 0 .304-.396c.055-.156.083-.543.083-1.15v-1.803h1.104v4.277H41.85z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.732 57.83c-.911 0-1.591-.322-2.051-.947-.34-.478-.515-1.085-.515-1.785 0-.837.23-1.527.681-2.024a2.3 2.3 0 0 1 1.775-.782c.782 0 1.417.276 1.877.819.442.524.662 1.288.644 2.29v.193l.12.018-.202.589c-.175.515-.469.929-.865 1.205-.405.285-.892.423-1.463.423z",
    style: {
      fill: "#e44055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.449 55.843 1.104.193c-.138.414-.368.727-.671.947s-.69.322-1.15.322c-.727 0-1.269-.239-1.619-.727-.276-.386-.414-.883-.414-1.472 0-.708.184-1.269.543-1.665.359-.405.819-.598 1.38-.598.626 0 1.113.212 1.472.635s.534 1.067.515 1.932H44.83c.009.34.092.598.267.782s.386.276.635.276a.616.616 0 0 0 .432-.147c.138-.11.23-.267.285-.478zm.064-1.141c-.009-.331-.092-.58-.248-.745a.74.74 0 0 0-.58-.258.773.773 0 0 0-.598.267c-.156.184-.239.423-.23.736h1.656z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaAtlantic);
export default __webpack_public_path__ + "static/media/canada_atlantic.5ced920c621f851ab7433c0135c3d5c7.svg";
export { ForwardRef as ReactComponent };